import { QueryStringBuilder } from "@/utils";
import { createQuery } from "@/api";
import { Deal, DealFilter } from "./Deal.types";
import { Paginated } from "@/utilityTypes/pagination.types";
import { SfdcData, SfdcDataV2Response } from "./SFDC.types";

export const getDeal = createQuery<Deal>(({ api, router }) => {
    return api.get(`/deal-flow/v1/deals/${router.params.dealId}`);
});

export const getDeals = createQuery<Paginated<Deal>, DealFilter>(
    ({ api, params, pagination }) => {
        const queryString = new QueryStringBuilder()
            .ilike("name", params?.searchTerm)
            .in("status", params?.status)
            .add("max_page_size", pagination?.maxPageSize || 20)
            .build();
        const url = pagination?.currentUrl
            ? pagination.currentUrl.replace("/api", "")
            : `/deal-flow/v2/deals?${queryString}`;

        return api.get(url).then((res) => ({
            ...res,
            prev: res.links.prev ? `/deal-flow${res.links.prev}` : null,
            next: res.links.next ? `/deal-flow${res.links.next}` : null,
            items: res.items.sort(
                (a, b) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime(),
            ),
        }));
    },
);

export const getSFDCData = createQuery<SfdcData[]>(async ({ api, router }) => {
    const response = await api.get(
        `/deal-flow/v1/sfdc_data/${router.params.companyId}`,
    );

    return response?.sfdcData;
});

export const getSFDCDataV2 = createQuery<SfdcDataV2Response>(
    async ({ api, router }) => {
        return api.get(`/deal-flow/v2/sfdc_data/${router.params.companyId}`);
    },
);
